/**
 * Prompt — a governed, versioned prompt in the shared library.
 * Source: Marko spec §7. coreBOS-A: new module; versioning + voting are native.
 *
 * `versione` auto-increments on every edit (calcolato by coreBOS; stored here for projection).
 * `voti` is calcolato — sum of community votes (not stored here, read from projection).
 * States: Bozza → Pubblicato → Deprecato.
 * Prompt bodies may embed real client data as examples — flag for data-governance review.
 */
export const promptDescriptor = {
    slug: 'prompt',
    kind: 'document',
    label: { singular: 'Prompt', plural: 'Prompt' },
    table: 'ai_portal_prompt',
    idStrategy: 'sha256',
    fields: [
        { name: 'titolo', type: 'text', label: 'Titolo', required: true },
        { name: 'testo_prompt', type: 'text', label: 'Testo prompt', required: true },
        { name: 'versione', type: 'number', label: 'Versione' }, // auto-increment
        { name: 'strumento_target', type: 'text', label: 'Strumento target' },
        // Copilot | Agente custom | Altro
        { name: 'area', type: 'text', label: 'Area' }, // aree/funzioni del cliente
        { name: 'voti', type: 'number', label: 'Voti community' }, // calcolato
        { name: 'stato', type: 'text', label: 'Stato', required: true },
        // Bozza | Pubblicato | Deprecato
    ],
    relations: [
        { name: 'autore', kind: 'belongsTo', target: 'ai_user' },
        { name: 'progetto_ai_lab', kind: 'belongsTo', target: 'ai_lab_project' },
    ],
    behaviors: {
        ownership: true,
        audit: true,
        numbering: { prefix: 'PRM', seq: 'ai_portal_prompt_no' },
        tenantScoped: true,
    },
    emits: ['prompt.published', 'prompt.deprecated'],
    ui: { mode: 'generated', icon: 'CodeOutlined', navGroup: 'Ricerca', navOrder: 21 },
};
